import { Card } from '@tecsinapse/cortex-react'
import React from 'react'
import { gql } from 'graphql-request'
import { useQuery } from '@tanstack/react-query'
import {
  LinkDownloadByArquivoQueryQuery,
  LinkDownloadByArquivoQueryQueryVariables
} from '../types/graphql'
import { request } from '../utils/request'
import { EventGoal, EventOrigin, logEvent } from '../analytics'
import { AnalyticsEvents } from '../analytics/analytics-eventes-enum'

export const linkDownloadByArquivoQueryGql = gql`
  query LinkDownloadByArquivoQuery($idArquivo: ID!) {
    linkDownloadByArquivo(idArquivo: $idArquivo)
  }
`

export const AnuncioCard = ({
  titulo,
  link,
  linkTarget = '_blank',
  idArquivo
}: any) => {
  const { data } = useQuery({
    queryKey: ['linkDownloadByArquivo'],
    queryFn: async () =>
      await request<
        LinkDownloadByArquivoQueryQuery,
        LinkDownloadByArquivoQueryQueryVariables
      >(linkDownloadByArquivoQueryGql, { variables: { idArquivo } }),
    enabled: !!idArquivo
  })

  const backgroundImage = data?.linkDownloadByArquivo ?? null

  return (
    <a
      href={link}
      target={linkTarget}
      rel='noopener noreferrer'
      className='no-underline'
      title={titulo ?? ''}
      onClick={() => {
        logEvent({
          name: AnalyticsEvents.CARD_ANUNCIO,
          params: {
            origin: EventOrigin.button,
            goal: EventGoal.navigation
          }
        })
      }}
    >
      <Card className='px-0 py-0 flex flex-col w-full h-full rounded-mili overflow-hidden'>
        {backgroundImage ? (
          <img
            src={backgroundImage}
            alt={titulo ?? ''}
            className='w-full flex-1 object-cover rounded-t-mili'
          />
        ) : (
          <div className='w-[244px] h-[360px] flex-1 flex items-center justify-center text-base border rounded-t-mili' />
        )}
      </Card>
    </a>
  )
}
